import DispensaryProductPage from 'src/dispensary/product';
import { createStorePageServerSideProps } from 'src/utils/ssr/get-dispensary-server-side-props';
import { prefetchPdpProduct } from 'src/utils/ssr/prefetch-pdp-product';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';
import { withLayout } from 'src/components/layouts/with-layout';

export const getServerSideProps = createStorePageServerSideProps(prefetchPdpProduct);

export default withLayout(DispensaryProductPage, CoreMenuLayout);
